export interface DatePreset {
	id: string;
	label: string;
	getRange: () => {from: string; to: string};
}

function toISODate(date: Date): string {
	return date.toISOString().split('T')[0]!;
}

function today(): Date {
	const d = new Date();
	d.setHours(0, 0, 0, 0);
	return d;
}

export const DATE_PRESETS: DatePreset[] = [
	{
		id: 'today',
		label: 'Today',
		getRange: () => {
			const d = toISODate(today());
			return {from: d, to: d};
		},
	},
	{
		id: 'yesterday',
		label: 'Yesterday',
		getRange: () => {
			const d = today();
			d.setDate(d.getDate() - 1);
			const iso = toISODate(d);
			return {from: iso, to: iso};
		},
	},
	{
		id: 'last_7_days',
		label: 'Last 7 days',
		getRange: () => {
			const end = today();
			const start = new Date(end);
			start.setDate(start.getDate() - 6);
			return {from: toISODate(start), to: toISODate(end)};
		},
	},
	{
		id: 'last_30_days',
		label: 'Last 30 days',
		getRange: () => {
			const end = today();
			const start = new Date(end);
			start.setDate(start.getDate() - 29);
			return {from: toISODate(start), to: toISODate(end)};
		},
	},
	{
		id: 'this_month',
		label: 'This month',
		getRange: () => {
			const end = today();
			const start = new Date(end.getFullYear(), end.getMonth(), 1);
			return {from: toISODate(start), to: toISODate(end)};
		},
	},
	{
		id: 'last_month',
		label: 'Last month',
		getRange: () => {
			const now = today();
			const start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
			const end = new Date(now.getFullYear(), now.getMonth(), 0);
			return {from: toISODate(start), to: toISODate(end)};
		},
	},
	{
		id: 'this_quarter',
		label: 'This quarter',
		getRange: () => {
			const now = today();
			const quarterStart = Math.floor(now.getMonth() / 3) * 3;
			const start = new Date(now.getFullYear(), quarterStart, 1);
			return {from: toISODate(start), to: toISODate(now)};
		},
	},
];
